import {Storage} from 'utils/storage'
import config from '../config'

const tokenStore = new Storage()

export function getTokenForStorage() {
    return tokenStore.getItem(config.accessTokenKey)
}

export function removeTokenForStorage() {
    return tokenStore.removeItem(config.accessTokenKey)
}

export function setTokenForStorage(token) {
    return tokenStore.setItem(config.accessTokenKey, token)
}
